// logger.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private isLoggingEnabled = false;

  enableLogging() {
    this.isLoggingEnabled = true;
  }

  disableLogging() {
    this.isLoggingEnabled = false;
  }

  log(message: any, ...optionalParams: any[]) {
    if (this.isLoggingEnabled) {
      console.log(message, ...optionalParams);
    }
  }

  warn(message: any, ...optionalParams: any[]) {
    if (this.isLoggingEnabled) {
      console.warn(message, ...optionalParams);
    }
  }

  error(message: any, ...optionalParams: any[]) {
    if (this.isLoggingEnabled) {
      console.error(message, ...optionalParams);
    }
  }
}